const IS_BACKEND_AS_PER_FRONTEND =
  import.meta.env.VITE_IS_BACKEND_AS_PER_FRONTEND === "true";
export let BASE_API_URL = import.meta.env.VITE_BASE_API_URL;

if (IS_BACKEND_AS_PER_FRONTEND) {
  const frontendHost = window.location.hostname;
  if (frontendHost === "cpgramsaichatbot.com") {
    BASE_API_URL = "https://chatbot.cpgramsaichatbot.com/";
  } else if (frontendHost.includes("azurewebsites.net")) {
    //BASE_API_URL = "http://backend.aibott.org:1890/";
    BASE_API_URL = "https://chatbot.cpgramsaichatbot.com/";
  } else if (frontendHost === "localhost" || frontendHost === "127.0.0.1") {
    BASE_API_URL = "http://20.197.22.47:1890/";
    // BASE_API_URL = "https://chatbot.cpgramsaichatbot.com/";
  }
}

export const API_VERSION = import.meta.env.VITE_API_VERSION;
export const BASE_URL = `${BASE_API_URL}${API_VERSION}`;
export const NIC_API_URL =
  import.meta.env.VITE_NIC_API_URL ||
  "https://pgportal.gov.in/ReformsServices/api/";

export const API_ENDPOINTS = {
  languageDetection: `${BASE_URL}input_query_lang`, // TLD
  generateContent: `${BASE_URL}jb_categorize_grievance`, // Main bot api
  transliterate: `${BASE_URL}transliterate`, // translitration
  generateAudio: `${BASE_API_URL}process_audio`, // unused
  speech2text: `${BASE_API_URL}speech2text`, // used as fallback in voice input
  liveDepartments: `${BASE_URL}live_departments`, // unused
  audioLanguageDetection: `${BASE_API_URL}audio_lang_detection`, // ALD
  botResponseStatus: `${BASE_URL}identified_properties`, // unused
  logger_url: `${BASE_API_URL}frontend_logger`, // frontend logger
  getAdditionalDropdownValueList: `${BASE_API_URL}get_additional_dropdown_value_list`, // NIC API for field form data
  searchAdditionalFields: `${BASE_API_URL}search_additional_fields`, // NIC API for searching additional fields
  getUserProfileNIC: `${BASE_URL}get_userid_nic`, // NIC Auth API
  registerGrievance: `${BASE_URL}lodge_grievance_reformed`, // Reformed grievance registration
  frontend_timing_logger: `${BASE_API_URL}frontend_timing_logger`, // frontend timing logger
  registerStateGrievance: `${BASE_URL}lodge_grievance_nonreformed`, // Non reformed grievance registration
  progressUpdateOnGrievance: `${BASE_URL}progress`, // Polling status
  forceToCenter: `${BASE_URL}set_state_flag_forced`, // Force to center API
  authenticateUser: `${BASE_URL}authenticate`, // User authentication API
};

// /v1/progress
// curl -X 'GET' \
//   'http://localhost:1890/v1/progress' \
//   -H 'accept: application/json' \
//   -H 'x-source: fec4bfdb_2d06_4d79_bd1b_82a486a54a68'

export const NIC_APIS = {
  getAdditionalFields: `${NIC_API_URL}/GetAdditionalDropdownValueList`,
};

export const ORGANISATION_CATEGORY_CODES = [
  "28154",
  "28155",
  "28156",
  "28157",
  "28158",
  "28159",
  "28160",
  "28161",
  "28170",
  "28164",
  "28165",
  "28166",
  "28167",
  "28168",
  "28169",
  "28171",
  "28172",
  "28173",
  "28174",
  "28175",
  "28176",
  "28177",
  "28178",
  "28179",
  "28180",
  "28181",
  "28182",
  "28183",
  "28184",
  "28185",
  "28186",
  "28187",
  "28188",
  "28189",
  "28190",
  "28191",
  "28192",
  "28193",
  "28194",
  "28195",
  "28196",
  "28197",
  "28198",
  "28199",
  "28200",
  "28201",
  "28202",
  "28203",
  "28204",
  "28205",
  "28206",
  "28139",
  "28268",
  "28269",
  "28208",
  "28270",
  "28271",
  "28210",
  "28272",
  "28273",
  "28274",
  "28275",
  "28276",
  "28277",
  "28278",
  "28279",
  "28280",
  "28215",
  "28216",
  "28220",
  "28221",
  "28222",
  "28281",
  "28282",
  "28224",
  "28225",
  "28283",
  "28284",
  "28227",
  "28228",
  "28229",
  "28230",
  "28231",
  "28232",
  "28233",
  "28234",
  "28235",
  "28236",
  "28237",
  "28285",
  "28286",
  "28287",
  "28288",
  "28239",
  "28240",
  "28241",
  "28242",
  "28247",
  "28243",
  "28244",
  "28149",
];
